import { render } from "./PageServices.vue?vue&type=template&id=78785288&scoped=true"
import script from "./PageServices.vue?vue&type=script&lang=js"
export * from "./PageServices.vue?vue&type=script&lang=js"

import "./PageServices.vue?vue&type=style&index=0&id=78785288&lang=scss&scoped=true"

import exportComponent from "/tmp/build_c77b6d3d/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78785288"]])

export default __exports__